import { PaymentSessionStatus } from '../../../../core/models/PaymentSessionStatus.enum';
import { paymentHttpClient } from '../../../http/axios/axios-http-client';
import { CreatePaymentSessionForBookingRequestDTO } from './dto/CreatePaymentSessionForBookingRequestDTO';
import { CreatePaymentSessionForMultipleBookingsRequestDTO } from './dto/CreatePaymentSessionForMultipleBookingsRequestDTO';

const PUBLIC_ENDPOINT = '/public/payment';

export interface PaymentGateway {
  createPaymentSessionForSingleBooking(body: CreatePaymentSessionForBookingRequestDTO): Promise<string>;
  createPaymentSessionForMultipleBookings(body: CreatePaymentSessionForMultipleBookingsRequestDTO): Promise<string>;
  getPaymentSessionStatus(sessionId: string): Promise<PaymentSessionStatus>;
}

export interface PaymentSession {
  transactionId: string;
  currency: string;
  amount: number;
  status: string;
}

export class PaymentGateway implements PaymentGateway {
  async createPaymentSessionForSingleBooking(body: CreatePaymentSessionForBookingRequestDTO): Promise<string> {
    const endpoint = `${PUBLIC_ENDPOINT}/get-client-secret`;
    const response = await paymentHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: body,
    });
    return response.data;
  }

  async createPaymentSessionForMultipleBookings(body: CreatePaymentSessionForMultipleBookingsRequestDTO): Promise<string> {
    const endpoint = `${PUBLIC_ENDPOINT}/multiple-bookings/get-client-secret`;
    const response = await paymentHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: body,
    });
    return response.data;
  }

  async getPaymentSessionStatus(sessionId: string): Promise<PaymentSessionStatus> {
    const endpoint = `${PUBLIC_ENDPOINT}/session-status/${sessionId}`;
    const response = await paymentHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }

  async getPaymentSession(sessionId: string): Promise<PaymentSession> {
    const endpoint = `${PUBLIC_ENDPOINT}/session/${sessionId}`;
    const response = await paymentHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }
}
